import { Pipe, PipeTransform } from "@angular/core";
import { EntityReferenceDto } from "@sortapp/app/models/commondto/EntityReference";
import { PlatzierungszustandDefaults } from "@sortapp/app/models/Sortimente/Platzierungaenderung";
import { SetTypesSortimentierenDefaults } from "@sortapp/app/models/Sortimente/SetType";
import { StatusSomaSortimentierenDefaults } from "@sortapp/app/models/Sortimente/StatusSomaSortimentieren";
import { GeneralResultEnum, NoviColumn, NumberColumn, SetTypeEnum, SimpleResult, WupColumnType } from "FoxxyInterfaces";
import { CommonCheckService, MoebelService, StatusPflegeDefaults, StichwortTreeService } from "FoxxyLib";
import { VatTypeTextEnum } from "../models/SomaDatenDto";
import { StatusWupSortimentierenDefaults } from "@sortapp/app/models/Sortimente/StatusWupSortimentieren";
import { DecimalPipe } from "@angular/common";
import { JWWSTransferTypeGraphqlEnum, StatusTransferTypeSortimentierenDefaults } from "@sortapp/app/models/Sortimente/StatusTransferTypeSortimentieren";
import { StatusPflegeSortimentierenDefaults } from "@sortapp/app/models/Sortimente/StatusPflegestatusSortimentieren";



@Pipe({
  name: 'sortimentStringPipe',
  standalone: true
})
/**für schnelle Readonly Anzeige
 * berücksichtigt die speziellen Spalten und Daten aus Sortimentieren
*/
export class SortimentStringPipe implements PipeTransform {

  constructor(private lipovalidate: CommonCheckService,
    private moebelservice: MoebelService,
    private treeservice: StichwortTreeService) { }

  transform(val: any, ...args: any[]): any {
    let result = val;
    const row = args[0];
    const col = args[1];
    try {
      switch (col.type) {
        case WupColumnType.CheckBox:
         
          result = val == true ? 'Ja' : (val == false ? 'Nein' : undefined);
          break;
        case WupColumnType.StartStop:

          if (val[col.startstop.start.field] != null) {
            result = this.lipovalidate.getDateasString(val[col.startstop.start.field]);
          }
          if ((val[col.startstop.stop.field] != null)) {
            result += " " + this.lipovalidate.getDateasString(val[col.startstop.stop.field]);
          }
          break;
        case WupColumnType.Chips:
          if (val instanceof Array) {
            if (val.length == 0) return null;
            if (col.chips?.field == undefined) {
              result = val.length > 0 ? val.join(",") : undefined;
            } else {
              result = val.length > 0 ? val.map(f => f[col.chips.field]).join(",") : undefined;
            }
          }
          break;
        case WupColumnType.Number:
          const digitinfo = col.numberData && col.numberData.minFractionDigits && col.numberData.maxFractionDigits ? '1.' + col.numberData.minFractionDigits + '-' + col.numberData.maxFractionDigits : null;
          result = new DecimalPipe('de-DE').transform(val, digitinfo);
          break;
        case WupColumnType.AutoComplete:

          if (val instanceof Array) {
            if (val.length == 0) return null;
            if (col.autocomplete?.field == undefined) {
              result = val.length > 0 ? val.join(",") : undefined;
            } else {
              result = val.length > 0 ? val.map(f => f[col.autocomplete.field]).join(",") : undefined;
            }
          }
          break;
        case WupColumnType.Tree:
          /**in Treenodes suchen */

          if (col.field.toLowerCase().startsWith('aktuelleplatzierungen')
            && (col.field.toLowerCase().endsWith('moebel_value')
              || col.field.toLowerCase().endsWith('moebelname_value')
            )
          ) {
            if (val == null) {
              return row[col.field.replace('_value', '')];
            }
            if (val.key) // nodekey
            {
              const moebel = row['sortiment_id'] ? this.moebelservice.moebelHierarchieSub.value[row['sortiment_id']] : [];
              if (moebel)
                {
                    const deepvalue = this.lipovalidate.findDeepValue(moebel, 'id', Number(val.key));
                    result = deepvalue?.name;
                } else
                {
                  result = val?.label;
                }
            }
            if (!result) {
              result = row[col.field.replace('_value', '')];
            }
            if (val && !result) {
              result = 'Unbekanntes Möbel (' + (val?.label ?? val) + ')';
            }
          } else
            if (col.field.toLowerCase() == 'stichwort_id'
            ) {
              col.treeSelect.lookupModel.subscribe(s => {
                const stichwort = this.treeservice.findStichwortNode(s, val);
                if (stichwort) {
                  result = stichwort?.data?.stichwortName;
                } else {
                  result = row["stichwort_name"]; // alternativ, wenn im Baum nicht gefunden
                }
              })
            }

          break;
        case WupColumnType.Date:
          result = val != undefined ? this.lipovalidate.toDateText(val) : undefined;
          break;
        case WupColumnType.DropDown:
          if (col.field.toLowerCase() == 'artikel_hersteller_id') {
            col.dropDown.lookupModel.subscribe(s => {
              result = s.find(g => g.value == val)?.name; // nur die nummer
              if (result == null && row["artikel_hersteller_name"]) {
                result = row["artikel_hersteller_name"];
              }
            })
            break;
          }
          else if (col.field.toLowerCase() == 'productgroupeffective_value') {
            col.dropDown.lookupList.subscribe(s => {
              result = s.find(g => g.value == val)?.value; // nur die nummer
            })

            break;
          } else if (col.field.toLowerCase().startsWith('vkvattypeeffective')) {
            result = this.lipovalidate.getArrayofTextEnum(VatTypeTextEnum).find(f => f.value == val)?.key;
            break;
          } else
            // Zustand
            if (col.field.toLowerCase().startsWith('platzierungen_aenderung') || col.field.toLowerCase() == 'aenderung') {
              result = val != undefined ? PlatzierungszustandDefaults.list.find(t => t.value == val)?.text : undefined;
              break;
            } else if (col.field.toLowerCase().startsWith('artikel_sets_settype')) {
              result = val != undefined ? SetTypesSortimentierenDefaults.list.find(f => f.value == val)?.text : undefined;
              break;
            } else if (col.field.toLowerCase() == 'statussoma_status') {
              result = val != undefined ? StatusSomaSortimentierenDefaults.list.find(f => f.value == val)?.text : undefined;
              break;
            } else if (col.field.toLowerCase() == 'statuswup_status') {
              result = val != undefined ? StatusWupSortimentierenDefaults.list.find(f => f.value == val)?.text : undefined;
            } else if (col.field.toLowerCase() == 'artikel_jwws_pflegestatus' || col.field.toLowerCase() == 'artikel_jwwspflegestatus') {
              result = val != undefined ? StatusPflegeSortimentierenDefaults.list.find(f => f.value.toString() == val)?.text : undefined;
              break;
            } else if (col.field.toLowerCase().startsWith('platzierungen_moebel_id')) {
              col.dropDown.lookupList.subscribe(s => {
                result = this.lipovalidate.findDeepValue(s, 'id', val)?.name;
                if (!result) {
                  result = result = row[col.field.replace('_id', '_name')];
                }
                if (val && !result) {
                  result = 'unbekanntes Möbel (' + val + ')';
                }
              })
              break;
            }
            else if (col.field.toLowerCase() == 'sortiment_id'
              || col.field.toLowerCase() == 'klammer_id') {
              col.dropDown.lookupList.subscribe(s => {
                result = s.find(g => g.id == val)?.name;
              })
            }
            else if (val != undefined && col.dropDown && col.dropDown.optionLabel && val[col.dropDown.optionLabel] != undefined) {
              result = val[col.dropDown.optionLabel];
            } else {
              result = val;
            }
          break;

        case WupColumnType.MultiSelect:

          // aus Daten wenn vorhanden

          if (col.field == 'artikel_saison_shortId' && row["artikel_saison_shortId"] instanceof Array) {
            result = row["artikel_saison_shortId"].filter(f => f.name).map(m => m.name).join(",");
            if (result && result.length > 0) return result;
          } else if (col.field == 'artikel_jwwsTransferTypes_value' && row["artikel_jwwsTransferTypes_value"] instanceof Array) {
            let listresult = null;
            StatusTransferTypeSortimentierenDefaults.list.forEach(s => {
              if (row["artikel_jwwsTransferTypes_value"].find(f => f as JWWSTransferTypeGraphqlEnum == s.value)) {
                listresult = listresult ? listresult + "," + s.text : s.text;
              }
            })

            if (listresult && listresult.length > 0) return listresult;
          }
          // aus lookups
          if (col.field.toLowerCase().startsWith('artikel_saison_shortid')
          ) {
            col.multiSelect.lookupList.subscribe(s => {
              result = val instanceof Array ? s.filter(g => val.find(v => v[col.multiSelect.dataKey] == g.id)).map(m => m[col.multiSelect.optionLabel]).join(",") : null;
            })
            break;
          }
          if (col.field.toLowerCase().startsWith('artikel_saison_shortid')
            || col.field.toLowerCase().startsWith('artikel_region_shortid')
            || col.field.toLowerCase() == 'platzierungen_moebel_id'
          ) {
            col.multiSelect.lookupList.subscribe(s => {
              result = val instanceof Array ? s.filter(g => val.find(v => v[col.multiSelect.optionValue] == g.id)).map(m => m[col.multiSelect.optionLabel]).join(",") : null;
            })
            break;
          } else if (val instanceof Array) {
            if (col.multiSelect.optionLabel) {
              result = val.length > 0 ? val.map(g => g[col.multiSelect.optionLabel]).join(",") : undefined;
            }
            else {
              result = val.length > 0 ? val.map(g => g).join(",") : undefined;
            }
          } else {
            result = val;
          }

          break;

        case WupColumnType.Label:

          if (col.field.toLowerCase().startsWith('vkvattypeeffective')) {
            result = this.lipovalidate.getArrayofTextEnum(VatTypeTextEnum).find(f => f.value == val)?.key;
            break;
          }
          else if (col.field.toLowerCase() == 'productgroupeffective_value') {
            col.dropDown.lookupList.subscribe(s => {
              result = s.find(g => g.value == val)?.value;
            })
          } else if (col.field.toLowerCase().startsWith('artikel_sets_settype')) {
            result = val != undefined ? SetTypesSortimentierenDefaults.list.find(f => f.value == val)?.text : undefined;
          } else if (col.field.toLowerCase() == 'sortiment_id'
            || col.field.toLowerCase() == 'klammer_id') {
            col.dropDown.lookupList.subscribe(s => {
              result = s.find(g => g.id == val)?.name;
            })
          }
          else if (col.field.toLowerCase().startsWith('platzierungen_aenderung') || col.field.toLowerCase() == 'aenderung') {
            result = val != undefined ? PlatzierungszustandDefaults.list.find(t => t.value == val)?.text : undefined;
          }
          else if (col.field.toLowerCase() == 'statussoma_status') {
            result = val != undefined ? StatusSomaSortimentierenDefaults.list.find(f => f.value == val)?.text : undefined;
          } else if (col.field.toLowerCase() == 'stichwort_id') {
            result = row["stichwort_name"]; // label
          } else if (col.field.toLowerCase() == 'statuswup_status') {
            result = val != undefined ? StatusWupSortimentierenDefaults.list.find(f => f.value == val)?.text : undefined;
          }
          //Format date
          else if (col.dateColumn && col.dateColumn.format) {
            // Default Date als Ganztag
            result = this.lipovalidate.toDateText(val)
          } else if (val != undefined && col.dropDown && col.dropDown.optionLabel && val[col.dropDown.optionLabel] != undefined) {
            // Format dropdown
            result = val[col.dropDown.optionLabel];
          } else if (val != undefined && col.multiSelect) {
            // Format multiselect
            if (val instanceof Array) {
              if (col.multiSelect.optionLabel) {
                result = val.length > 0 ? val.map(g => g[col.multiSelect.optionLabel]).join(",") : undefined;
              }
              else {
                result = val.length > 0 ? val.map(g => g).join(",") : undefined;
              }
            }
          } else if (val != undefined && col.numberData != undefined) {
            const digitinfo = col.numberData && col.numberData.minFractionDigits && col.numberData.maxFractionDigits ? '1.' + col.numberData.minFractionDigits + '-' + col.numberData.maxFractionDigits : null;
            result = new DecimalPipe('de-DE').transform(val, digitinfo);
          } else if (val != undefined && col.integerData != undefined && Number.isInteger(val)) {
            result = new DecimalPipe('de-DE').transform(val, '1.0-0');
          }
          else {
            result = val;
          }
          break;
        default:
          result = val;
          break;
      }
    } catch (e) {
      this.lipovalidate.onError?.emit(<SimpleResult>{ userMessage: 'Daten darstellen -> ' + col.field, serverMessage: e.toString(), generalResult: GeneralResultEnum.OnlyDebug })
    }
    return result;
  }

}
